{
  "rememberMe": "Se souvenir de moi",
  "signIn": "Se connecter",
  "signUp": "Créer un compte",
  "signUpLink": "Vous n'avez pas de compte ?",
  "continueAsGuest": "Continuer en tant qu'invité",
  "forgotPassword": "Mot de passe oublié",
  "forgotPasswordLink": "Vous avez oublié votre mot de passe ?",
  "setPassword": "Définir le mot de passe",
  "codeVerification": "Vérification du code",
  "verifyMessage": "Nous avons envoyé un code de vérification à votre adresse e-mail",
  "changePassword": "Modifier le mot de passe",
  "signOut": "Se déconnecter",
  "deleteAccount": "Supprimer le compte",
  "availableProfiles": "Profils disponibles",
  "selectProfile": "Sélectionner un profil",
  "noProfiles": "Aucun profil disponible",
  "switchProfile": "Changer de profil",
  "alreadyHaveCode": "Vous avez déjà un code de vérification ?",
  "tempPassMessage": "Veuillez remplacer votre mot de passe temporaire",
  "mfa": {
    "settings": "Paramètres MFA",
    "SMS": "SMS",
    "TOTP": "Application d'authentification",
    "noPreference": "Aucune préférence",
    "enabledMFAMethods": "Méthodes MFA activées",
    "preferredMFAMethod": "Méthode MFA préférée",
    "setupTOTPMFA": "Configurer la MFA par application d'authentification",
    "setupSMSMFA": "Configurer la MFA par SMS",
    "disableTOTPMFA": "Désactiver la MFA par application d'authentification",
    "disableSMSMFA": "Désactiver la MFA par SMS",
    "TOTPSetup": "Configuration de l'application d'authentification",
    "SMSSetup": "Configuration des SMS",
    "secretKey": "Clé secrète",
    "installAuthApp": "Installez une application d'authentification sur votre appareil mobile",
    "addAnAccount": "Ajouter un compte",
    "scanQRCode": "Scannez le QR code suivant :",
    "or": "Ou...",
    "addSecretManually": "Ajoutez la clé secrète manuellement dans votre application d'authentification :",
    "copySecretKey": "Copier la clé secrète",
    "regenSecretKey": "Régénérer la clé secrète",
    "ensureAccountCreated": "Assurez-vous que le compte '{appName}' a bien été créé",
    "verifySetup": "Vérifiez votre configuration :",
    "done": "Terminé",
    "otpMessage": "Saisissez le code à usage unique fourni par votre application d'authentification",
    "smsMessage": "Nous vous avons envoyé un code de vérification par SMS",
    "setupAuthAppMessage": "Besoin de configurer votre application d'authentification ?",
    "signUpOptionalMobileMessage": "En ajoutant votre numéro de mobile, vous pourrez utiliser les SMS pour l'authentification multifacteur (MFA). Si vous n'ajoutez pas de numéro de mobile, vous devrez configurer la MFA à l'aide d'une application d'authentification (comme Google Authenticator) lors de votre première connexion.",
    "mfaSelectionHeader": "Choix de la MFA",
    "mfaSelectionMessage": "Veuillez choisir comment vous souhaitez recevoir votre code à usage unique"
  },
  "ssoButtons": {
    "divider": "ou",
    "continueSso": "Continuer avec SSO",
    "continueMs": "Continuer avec Microsoft",
    "continueGoogle": "Continuer avec Google",
    "continueApple": "Continuer avec Apple"
  }
}
